import { useEffect, useContext } from "react";
import apiClient from "../api/client";
import { AuthContext } from "../App";

/**
 * Sends a presence heartbeat to the backend every 30 seconds
 * while the user is authenticated.
 */
export function usePresenceHeartbeat() {
  const { token } = useContext(AuthContext);

  useEffect(() => {
    if (!token) return;

    let cancelled = false;

    const sendHeartbeat = async () => {
      if (!token || cancelled) return;
      try {
        await apiClient.post(
          "/presence/heartbeat",
          { client: "web" },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (err) {
        // Silently ignore; presence is best-effort.
        // console.warn("[Presence] heartbeat failed", err);
      }
    };

    // send immediately, then every 30s
    sendHeartbeat();
    const id = setInterval(sendHeartbeat, 30000);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [token]);
}
